(function($) {

    'use strict';

    var init = function(){
        $('#eco-select').on('change', function(){
            $('.realisations__intro__eco-select').submit();
        })
    };

    $(document).ready(function() {
        if(
            ( $('body').hasClass('archive') && $('body').hasClass('category') )
            || ( $('body').hasClass('page-template-list-realisations') )
        ){
            init();
        }
    });

})(jQuery);
